var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "record-documents loading-content-container" },
    [
      _vm.isLoading
        ? _c(
            "div",
            {
              staticClass: "loading-overlay d-flex justify-content-center pt-5",
            },
            [_c("csp-loading-indicator")],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isLoading
        ? _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { cols: "8" } },
                [
                  _vm.canLoadDocuments
                    ? _c(
                        "b-row",
                        { staticClass: "mb-4" },
                        [
                          _c(
                            "csp-desktop-info-card",
                            {
                              attrs: {
                                cols: 12,
                                icon: "inticon-autoclaim_document_accident",
                                "link-icon": null,
                                "router-link": { name: "vehicleEditRoute" },
                                title: "Dokumente erzeugen",
                              },
                            },
                            [
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { cols: "3" } },
                                    [
                                      _c("csp-record-detail-documents-modal", {
                                        attrs: {
                                          "can-sign-documents":
                                            _vm.canSignDocuments,
                                          "record-id": _vm.recordId,
                                        },
                                        on: {
                                          "close-after-signature":
                                            _vm.updateFiles,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    { attrs: { cols: "3" } },
                                    [
                                      _c("csp-record-detail-document-print", {
                                        attrs: {
                                          "can-print-documents":
                                            _vm.canPrintDocuments,
                                          "document-list":
                                            _vm.documentsPrintable,
                                          "documents-loaded":
                                            _vm.recordDocumentsLoaded,
                                          "modal-type": "Dokumente drucken",
                                        },
                                        on: {
                                          "document-generated": _vm.updateFiles,
                                          "modal-opened": _vm.loadDocuments,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    { attrs: { cols: "3" } },
                                    [
                                      _c("csp-record-detail-document-print", {
                                        attrs: {
                                          "can-print-documents":
                                            _vm.canSendEmails,
                                          "document-list": _vm.documentsEmail,
                                          "documents-loaded":
                                            _vm.recordDocumentsLoaded &&
                                            _vm.recordFirmSpecificDocumentsLoaded,
                                          "firm-specific-document-list":
                                            _vm.recordFirmSpecificDocuments,
                                          "modal-type": "E-Mail versenden",
                                        },
                                        on: {
                                          "document-generated": _vm.updateFiles,
                                          "modal-opened":
                                            _vm.loadDocumentsAndFirmSpecificDocuments,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    { attrs: { cols: "3" } },
                                    [
                                      _c("csp-record-detail-document-print", {
                                        attrs: {
                                          "can-print-documents":
                                            _vm.canGenerateSpreadsheets,
                                          "document-list":
                                            _vm.documentsSpreadsheets,
                                          "documents-loaded":
                                            _vm.recordDocumentsLoaded,
                                          "modal-type": "Excel erzeugen",
                                        },
                                        on: {
                                          "document-generated": _vm.updateFiles,
                                          "modal-opened": _vm.loadDocuments,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "csp-desktop-info-card",
                        {
                          attrs: {
                            cols: 12,
                            icon: "inticon-autoclaim_document_accident",
                            "link-icon": null,
                            "router-link": { name: "vehicleEditRoute" },
                            title: "vorhandene Dokumente",
                          },
                        },
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c("csp-record-detail-document-upload", {
                                    attrs: { "record-id": _vm.recordId },
                                    on: { "upload-success": _vm.updateFiles },
                                  }),
                                  _vm._v(" "),
                                  _c("br"),
                                  _c("br"),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      class:
                                        "files-table" + _vm.recordFilesLoading >
                                        0
                                          ? "loading-content-container"
                                          : "",
                                    },
                                    [
                                      _vm.recordFilesLoading > 0
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "loading-overlay d-flex justify-content-center",
                                            },
                                            [_c("csp-loading-indicator")],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.recordFilesLoading === 0 &&
                                      _vm.recordFilesForTable.length === 0
                                        ? _c(
                                            "b-alert",
                                            {
                                              attrs: {
                                                show: "",
                                                variant: "info",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    Keine Dokumente vorhanden\n                                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "b-modal",
                                        {
                                          attrs: {
                                            "hide-footer": "",
                                            size: "lg",
                                            title:
                                              "Filter / Sortierung für Datum",
                                          },
                                          model: {
                                            value: _vm.isOrderModalOpen,
                                            callback: function ($$v) {
                                              _vm.isOrderModalOpen = $$v
                                            },
                                            expression: "isOrderModalOpen",
                                          },
                                        },
                                        [
                                          _c(
                                            "b-row",
                                            {
                                              staticClass: "table-legacy-modal",
                                              attrs: { "align-v": "center" },
                                            },
                                            [
                                              _c(
                                                "b-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _vm._v(
                                                    "\n                                            Sortierung\n                                        "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c(
                                                    "csp-form-select-searchable",
                                                    {
                                                      attrs: {
                                                        options:
                                                          _vm.orderValues,
                                                        value:
                                                          _vm.selectedOrderDirection,
                                                      },
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          return _vm.orderDocumentsByDateSet(
                                                            $event
                                                          )
                                                        },
                                                      },
                                                    }
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-button",
                                            {
                                              staticClass:
                                                "mt-3 modal-button right",
                                              attrs: {
                                                m: "",
                                                variant: "primary",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  _vm.isOrderModalOpen = false
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                        Sortierung anwenden\n                                    "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _vm.recordFilesLoading === 0 &&
                                      _vm.recordFilesForTable.length > 0
                                        ? _c("b-table", {
                                            attrs: {
                                              fields:
                                                _vm.visiblefileTableFields,
                                              items:
                                                _vm.categorisedOrPlainFilesForTable,
                                              responsive: true,
                                              "sort-by": _vm.selectedOrderValue,
                                              "sort-desc":
                                                _vm.selectedOrderDirection ===
                                                "desc",
                                              striped: "",
                                            },
                                            on: {
                                              "row-clicked":
                                                _vm.onFileTableRowClicked,
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "head(dateSet)",
                                                  fn: function (data) {
                                                    return [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticStyle: {
                                                            "column-gap":
                                                              "10px",
                                                          },
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v(
                                                              _vm._s(data.label)
                                                            ),
                                                          ]),
                                                          _vm._v(" "),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "filter-button ml-auto",
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    _vm.isOrderModalOpen = true
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "inticon-filter",
                                                              }),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  },
                                                },
                                                {
                                                  key: "table-colgroup",
                                                  fn: function (scope) {
                                                    return _vm._l(
                                                      scope.fields,
                                                      function (field) {
                                                        return _c("col", {
                                                          key: field.key,
                                                          style: {
                                                            width:
                                                              field.width ??
                                                              "auto",
                                                          },
                                                        })
                                                      }
                                                    )
                                                  },
                                                },
                                                {
                                                  key: "cell(amount)",
                                                  fn: function (data) {
                                                    return [
                                                      data.value > 1
                                                        ? _c("span", [
                                                            _c(
                                                              "a",
                                                              {
                                                                attrs: {
                                                                  href: "#",
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      $event.preventDefault()
                                                                      return _vm.toggleCategory(
                                                                        data
                                                                          .item
                                                                          .fileCategoryId
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                                                " +
                                                                    _vm._s(
                                                                      data.value
                                                                    ) +
                                                                    "\n                                            "
                                                                ),
                                                              ]
                                                            ),
                                                          ])
                                                        : _c("span", [
                                                            _vm._v(
                                                              "\n                                            " +
                                                                _vm._s(
                                                                  data.value
                                                                ) +
                                                                "\n                                        "
                                                            ),
                                                          ]),
                                                    ]
                                                  },
                                                },
                                                {
                                                  key: "cell(dateSet)",
                                                  fn: function (data) {
                                                    return [
                                                      _vm._v(
                                                        "\n                                        " +
                                                          _vm._s(
                                                            _vm.formatDateTime(
                                                              data.value
                                                            )
                                                          ) +
                                                          "\n                                    "
                                                      ),
                                                    ]
                                                  },
                                                },
                                                {
                                                  key: "cell(hideForGroup)",
                                                  fn: function (data) {
                                                    return [
                                                      _c("csp-hide-for-group", {
                                                        attrs: {
                                                          "can-toggle-fleet-manager-visibility":
                                                            data.item
                                                              .canToggleFleetManagerVisibility,
                                                          "default-value":
                                                            data.value,
                                                          "mandatory-hide-for-group":
                                                            data.item
                                                              .mandatoryHideForGroup ||
                                                            [],
                                                          options:
                                                            _vm.hideForGroupOptions,
                                                          "record-id":
                                                            _vm.recordId,
                                                          "toggle-visibility-url":
                                                            _vm.toggleVisibilityUrl(
                                                              data.item
                                                            ),
                                                        },
                                                        on: {
                                                          "fleet-manager-visibility-toggled":
                                                            function ($event) {
                                                              return _vm.toggleFleetManagerVisibility(
                                                                data.item.fileId
                                                              )
                                                            },
                                                          reload: _vm.loadFiles,
                                                        },
                                                      }),
                                                    ]
                                                  },
                                                },
                                                {
                                                  key: "cell(actions)",
                                                  fn: function (data) {
                                                    return [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "table-actions",
                                                        },
                                                        [
                                                          data.item
                                                            .canUseKlippaDataApplicationModal
                                                            ? _c(
                                                                "a",
                                                                {
                                                                  attrs: {
                                                                    href: "#",
                                                                    title:
                                                                      "Dokument auslesen",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        $event.preventDefault()
                                                                        return _vm.openKlippaModal(
                                                                          data
                                                                            .item
                                                                            .fileId
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _c("i", {
                                                                    staticClass:
                                                                      "inticon-autoclaim_weiterleiten",
                                                                  }),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          data.item.canPreview
                                                            ? _c(
                                                                "a",
                                                                {
                                                                  attrs: {
                                                                    href: _vm.getPreviewFileUrl(
                                                                      data.item
                                                                        .fileId
                                                                    ),
                                                                    target:
                                                                      "_blank",
                                                                    title:
                                                                      "Dokument in neuem Tab öffnen",
                                                                  },
                                                                },
                                                                [
                                                                  _c("i", {
                                                                    staticClass:
                                                                      "inticon-autoclaim_detail",
                                                                  }),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          data.item.canEdit
                                                            ? _c(
                                                                "a",
                                                                {
                                                                  attrs: {
                                                                    href: "#",
                                                                    title:
                                                                      "Bearbeiten",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        $event.preventDefault()
                                                                        _vm.editFileId =
                                                                          parseInt(
                                                                            data
                                                                              .item
                                                                              .fileId
                                                                          )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _c("i", {
                                                                    staticClass:
                                                                      "inticon-autoclaim_bearbeiten",
                                                                  }),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          data.item.canSplitFile
                                                            ? _c(
                                                                "a",
                                                                {
                                                                  attrs: {
                                                                    href: "#",
                                                                    title:
                                                                      "PDF aufteilen",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        $event.preventDefault()
                                                                        _vm.splitFileId =
                                                                          parseInt(
                                                                            data
                                                                              .item
                                                                              .fileId
                                                                          )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _c("i", {
                                                                    staticClass:
                                                                      "inticon-autoclaim_hinzufugen",
                                                                  }),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          _c(
                                                            "a",
                                                            {
                                                              attrs: {
                                                                href: _vm.getDownloadFileUrl(
                                                                  data.item
                                                                    .fileId
                                                                ),
                                                                title:
                                                                  "Datei herunterladen",
                                                              },
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "inticon-autoclaim_einzeldownload",
                                                              }),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "a",
                                                            {
                                                              attrs: {
                                                                href: _vm.getDownloadCategoryFilesUrl(
                                                                  data.item
                                                                    .fileCategoryId
                                                                ),
                                                                title:
                                                                  "Alle Dateien herunterladen",
                                                              },
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "inticon-autoclaim_mehrfachdownload",
                                                              }),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          data.item.canDelete
                                                            ? _c(
                                                                "a",
                                                                {
                                                                  attrs: {
                                                                    href: "#",
                                                                    title:
                                                                      "Löschen",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        $event.preventDefault()
                                                                        return _vm.deleteFile(
                                                                          data
                                                                            .item
                                                                            .fileId
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _c("i", {
                                                                    staticClass:
                                                                      "inticon-autoclaim_loschen",
                                                                  }),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                        ]
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              687047782
                                            ),
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          !_vm.isLoading && !_vm.recordFilesLoading
                            ? _c(
                                "b-row",
                                { staticClass: "mt-3" },
                                [
                                  _c(
                                    "b-col",
                                    [
                                      _c(
                                        "b-button",
                                        {
                                          on: {
                                            click: _vm.toggleAllCategories,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(
                                                _vm.toggleAllCategoriesButtonLabel
                                              ) +
                                              "\n                            "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "csp-desktop-info-card",
                {
                  attrs: {
                    cols: 4,
                    icon: "inticon-autoclaim_document_accident",
                    title: "Dokumentenvorschau",
                  },
                },
                [
                  _c("div", { staticClass: "loading-content-container" }, [
                    _vm.galleryIsLoading
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "loading-overlay d-flex justify-content-center",
                          },
                          [_c("csp-loading-indicator")],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.galleryIsLoading
                      ? _c(
                          "div",
                          [
                            _vm.galleryFiles.length > 0 &&
                            _vm.galleryActiveIndex != null
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "preview collapse-body mb-5",
                                    staticStyle: { height: "450px" },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.galleryActiveTitle,
                                            expression: "galleryActiveTitle",
                                          },
                                        ],
                                        staticClass:
                                          "galleryActiveTitle text-center mb-4",
                                      },
                                      [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(_vm.galleryActiveTitle) +
                                            "\n                            "
                                        ),
                                        _c("span", { staticClass: "mt-1" }, [
                                          _c("br"),
                                          _vm._v(
                                            " \n                                "
                                          ),
                                          _c(
                                            "span",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    _vm.currentGalleryFile &&
                                                    _vm.currentGalleryFile
                                                      .pageCount != null,
                                                  expression:
                                                    "currentGalleryFile && currentGalleryFile.pageCount != null",
                                                },
                                              ],
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    (" +
                                                  _vm._s(
                                                    _vm.currentGalleryFile
                                                      .pageCount
                                                  ) +
                                                  "\n                                    " +
                                                  _vm._s(
                                                    _vm.currentGalleryFile
                                                      .pageCount === 1
                                                      ? "Seite"
                                                      : "Seiten"
                                                  ) +
                                                  ")\n                                "
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("csp-file-gallery", {
                                      attrs: {
                                        "active-index": _vm.galleryActiveIndex,
                                        "disable-file-open":
                                          !_vm.canPreviewDocuments,
                                        files: _vm.galleryFiles,
                                        height: 400,
                                        width: 400 / 1.414,
                                      },
                                      on: { change: _vm.onGalleryChange },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.galleryFiles.length == 0
                              ? _c(
                                  "b-alert",
                                  { attrs: { show: "", variant: "info" } },
                                  [
                                    _vm._v(
                                      "\n                        Keine Dokumente vorhanden\n                    "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("csp-record-data-application-form-modal", {
        ref: "klippaModal",
        attrs: {
          "file-id": _vm.selectedKlippaFileId,
          "form-context": _vm.klippaDataApplicationFormContext,
          "record-id": _vm.recordId,
        },
        on: {
          created: _vm.updateFiles,
          reset: function ($event) {
            _vm.selectedKlippaFileId = null
          },
        },
      }),
      _vm._v(" "),
      _vm.editFileId
        ? _c("csp-record-detail-file-edit", {
            attrs: { "file-id": _vm.editFileId, "record-id": _vm.recordId },
            on: {
              reset: function ($event) {
                _vm.editFileId = null
              },
              updated: _vm.updateFiles,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.splitFileId
        ? _c("csp-record-document-split-modal", {
            attrs: { "file-id": _vm.splitFileId, "record-id": _vm.recordId },
            on: { close: _vm.onSplitModalClose },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }